import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService, LoggerService, UserRole } from '@oxypeak/commons';
import { map } from 'rxjs/operators';

// Guard that allows only logged-in SuperAdmins to access the route
@Injectable({ providedIn: 'root' })
export class AdminOnlyGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router,
    private logger: LoggerService
  ) {}

  canActivate() {
    // Check if the user is logged in and has the SuperAdmin role
    return this.authService.isLoggedIn$.pipe(
      map((isLoggedIn) => {
        const userRole = this.authService.getUserRole();
        if (isLoggedIn && userRole === UserRole.SuperAdmin) {
          // Allow access
          return true;
        }
        this.logger.warn('AdminOnlyGuard - Not authorized');
        // Redirect to /403 if not authorized
        return this.router.createUrlTree(['/403']);
      })
    );
  }
}
